var map = {
	"./address/menus/SettingsMenu": 848,
	"./companies/menus/SettingsMenu": 852,
	"./cost/menus/SettingsMenu": 855,
	"./cost/views/DoomPricesMenu": 250,
	"./cost/views/PricesMenu": 251,
	"./cost/views/additional_services/AdditionalServicesMenu": 81,
	"./cost/views/airport/AirportsMenu": 82,
	"./cost/views/extrasize/FreightExtrasizesMenu": 83,
	"./cost/views/luw/LuwsMenu": 252,
	"./cost/views/manipulator/ManipulatorsMenu": 253,
	"./cost/views/storage/StoragesMenu": 255,
	"./customers/menus/MainMenu": 907,
	"./deals/menus/MainMenu": 913,
	"./deals/menus/SettingsMenu": 914,
	"./finance/menus/MainMenu": 939,
	"./logs/menus/SettingsMenu": 943,
	"./module/menus/MainMenu": 947,
	"./module/menus/SettingsMenu": 948,
	"./reports/menus/MainMenu": 958,
	"./stock/menus/MainMenu": 976,
	"./stock/menus/SettingsMenu": 977,
	"./storekeepers_stocks/menus/MainMenu": 992,
	"./tasks/menus/FavoritesMenu": 1002,
	"./tasks/menus/MainMenu": 1003,
	"./users/menus/SettingsMenu": 1008
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1294;


//////////////////
// WEBPACK FOOTER
// ./src/modules Menu$
// module id = 1294
// module chunks = 0